<template>
  <div class="prep-main-summary">
    <div class="prep-main-summary-panel">
      <div class="prep-main-summary-title">
        1. sz. Szerződés melléklet
      </div>
      <div class="prep-main-summary-actions">
        <b-button
          size="sm"
          variant="outline-light"
          :disabled="isExportingPdf"
          @click="printSummary"
        >
          Nyomtatás
        </b-button>
        <b-button
          size="sm"
          variant="outline-info"
          :disabled="isExportingPdf"
          @click="openBudgetPdfViewer"
        >
          PDF előnézet
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          :disabled="isExportingPdf"
          @click="downloadBudgetPdf"
        >
          PDF letöltés
        </b-button>
        <b-button
          size="sm"
          variant="success"
          :disabled="mainSummaryMetaSaving"
          @click="saveMainSummaryMeta(false)"
        >
          {{ mainSummaryMetaSaving ? 'Mentés...' : mainSummaryMetaSaved ? 'Mentve' : 'Mentés' }}
        </b-button>
      </div>

      <div class="prep-main-summary-meta">
        <div class="prep-main-summary-meta-row">
          <div class="label">
            <div class="meta-box meta-box-label">
              Címzett
            </div>
          </div>
          <div class="value">
            <div class="meta-box meta-box-value">
              <input
                v-model="summaryData.recipient"
                type="text"
                class="meta-input"
                @input="scheduleMainSummaryMetaSave"
                @blur="saveMainSummaryMeta"
              >
            </div>
          </div>
        </div>
        <div class="prep-main-summary-meta-row">
          <div class="label">
            <div class="meta-box meta-box-label">
              Tárgy
            </div>
          </div>
          <div class="value">
            <div class="meta-box meta-box-value">
              <input
                v-model="summaryData.subject"
                type="text"
                class="meta-input"
                @input="scheduleMainSummaryMetaSave"
                @blur="saveMainSummaryMeta"
              >
            </div>
          </div>
        </div>
        <div class="prep-main-summary-meta-row">
          <div class="label">
            <div class="meta-box meta-box-label">
              Építés helye
            </div>
          </div>
          <div class="value">
            <div class="meta-box meta-box-value">
              <input
                v-model="summaryData.location"
                type="text"
                class="meta-input"
                @input="scheduleMainSummaryMetaSave"
                @blur="saveMainSummaryMeta"
              >
            </div>
          </div>
        </div>
        <div class="prep-main-summary-meta-row">
          <div class="label">
            <div class="meta-box meta-box-label">
              Munkaszám
            </div>
          </div>
          <div class="value">
            <div class="meta-box meta-box-value">
              <input
                v-model="summaryData.workId"
                type="text"
                class="meta-input"
                @input="scheduleMainSummaryMetaSave"
                @blur="saveMainSummaryMeta"
              >
            </div>
          </div>
        </div>
        <div class="prep-main-summary-meta-row">
          <div class="label">
            <div class="meta-box meta-box-label">
              Készült
            </div>
          </div>
          <div class="value">
            <div class="meta-box meta-box-value">
              <input
                v-model="summaryData.createdAt"
                type="text"
                class="meta-input"
                @input="scheduleMainSummaryMetaSave"
                @blur="saveMainSummaryMeta"
              >
            </div>
          </div>
        </div>
      </div>

      <div class="prep-main-summary-table-wrap">
        <table class="prep-main-summary-table">
          <colgroup>
            <col class="col-name">
            <col class="col-vat">
            <col class="col-material">
            <col class="col-fee">
          </colgroup>
          <thead>
            <tr>
              <th><div class="head-box">
                Megnevezés
              </div></th>
              <th class="vat-col">
                <div class="head-box" /></th>
              <th><div class="head-box">
                Anyagköltség
              </div></th>
              <th><div class="head-box">
                Díjköltség
              </div></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in excelLikeRows"
              :key="`excel-row-${index}`"
            >
              <td>
                <div class="cell-box cell-box-name">
                  {{ row.label }}
                </div>
              </td>
              <td class="vat-col">
                <div class="cell-box cell-box-vat">
                  <template v-if="row.isVatInput">
                    <div class="vat-input-wrap">
                      <input
                        v-model="vatPercentInput"
                        type="text"
                        class="vat-input"
                        @input="onVatInput"
                        @blur="formatVatInput"
                      >
                      <span class="vat-symbol">%</span>
                    </div>
                  </template>
                  <template v-else>
                    {{ row.vat }}
                  </template>
                </div>
              </td>
              <td
                v-if="row.isMergedAmount"
                colspan="2"
                class="merged-amount"
              >
                <div class="cell-box cell-box-merged">
                  {{ row.amount }}
                </div>
              </td>
              <template v-else>
                <td>
                  <div class="cell-box cell-box-number">
                    {{ row.material }}
                  </div>
                </td>
                <td>
                  <div class="cell-box cell-box-number">
                    {{ row.fee }}
                  </div>
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="prep-main-summary-highlight">
        <div class="line">
          <span>3. A munka NETTÓ ára:</span>
          <strong>{{ formatFt(mainTotalWithVat) }}</strong>
        </div>
        <div class="line">
          <span>4. Opciós munka NETTÓ ára:</span>
          <strong>{{ formatFt(optionalNetTotal) }}</strong>
        </div>
      </div>

      <div
        ref="notesPanel"
        class="prep-main-summary-notes"
        @click="openExcludedPopup"
      >
        <div class="notes-trigger">
          Az ajánlat NEM tartalmazza
        </div>
        <div
          v-if="checkedExcludedItems.length"
          class="notes-selected-list"
        >
          <div
            v-for="(item, index) in checkedExcludedItems"
            :key="`excluded-selected-${index}`"
            class="notes-selected-item"
          >
            {{ item }}
          </div>
        </div>

        <transition name="notes-pop">
          <div
            v-if="excludedPopupOpen"
            class="notes-popup"
            :class="`notes-popup--${excludedPopupDirection}`"
            @click.stop
          >
            <div class="notes-popup-title">
              Kizárt tételek checklista
            </div>

            <label
              v-for="(item, index) in excludedItems"
              :key="`excluded-check-${index}`"
              class="notes-item"
            >
              <input
                v-model="excludedChecked"
                type="checkbox"
                :value="item.id"
                @change="saveExcludedState"
              >
              <span>{{ item.text }}</span>
            </label>

            <div class="notes-add-row">
              <input
                v-model.trim="newExcludedItem"
                type="text"
                class="notes-add-input"
                placeholder="Új kizárt tétel hozzáadása..."
                @keyup.enter="addExcludedItem"
              >
              <button
                type="button"
                class="notes-add-btn"
                @click="addExcludedItem"
              >
                Hozzáad
              </button>
              <button
                type="button"
                class="notes-close-btn"
                @click="excludedPopupOpen = false"
              >
                Bezár
              </button>
            </div>
          </div>
        </transition>
      </div>

      <div
        ref="remarksPanel"
        class="prep-main-summary-notes prep-main-summary-remarks"
        @click="openRemarksPopup"
      >
        <div class="notes-trigger">
          Megjegyzések
        </div>
        <div
          v-if="checkedRemarksItems.length"
          class="notes-selected-list"
        >
          <div
            v-for="(item, index) in checkedRemarksItems"
            :key="`remarks-selected-${index}`"
            class="notes-selected-item"
          >
            {{ item }}
          </div>
        </div>

        <transition name="notes-pop">
          <div
            v-if="remarksPopupOpen"
            class="notes-popup"
            :class="`notes-popup--${remarksPopupDirection}`"
            @click.stop
          >
            <div class="notes-popup-title">
              Megjegyzések checklista
            </div>

            <label
              v-for="(item, index) in remarksItems"
              :key="`remarks-check-${index}`"
              class="notes-item"
            >
              <input
                v-model="remarksChecked"
                type="checkbox"
                :value="item.id"
                @change="saveRemarksState"
              >
              <span>{{ item.text }}</span>
            </label>

            <div class="notes-add-row">
              <input
                v-model.trim="newRemarksItem"
                type="text"
                class="notes-add-input"
                placeholder="Új megjegyzés hozzáadása..."
                @keyup.enter="addRemarksItem"
              >
              <button
                type="button"
                class="notes-add-btn"
                @click="addRemarksItem"
              >
                Hozzáad
              </button>
              <button
                type="button"
                class="notes-close-btn"
                @click="remarksPopupOpen = false"
              >
                Bezár
              </button>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <b-modal
      :visible="showPdfViewer"
      size="xl"
      hide-header
      hide-footer
      body-class="p-0"
      modal-class="budget-pdf-modal"
      @hidden="closePdfViewer"
    >
      <div class="budget-pdf-viewer">
        <div class="budget-pdf-header">
          <div class="budget-pdf-title">
            Költségvetés PDF előnézet
          </div>
          <div class="budget-pdf-controls">
            <b-button
              variant="link"
              size="sm"
              class="text-white p-1"
              :disabled="currentPage <= 1"
              @click="previousPage"
            >
              <feather-icon
                icon="ChevronLeftIcon"
                size="16"
              />
            </b-button>
            <span class="budget-pdf-indicator">{{ currentPage }} / {{ totalPages }}</span>
            <b-button
              variant="link"
              size="sm"
              class="text-white p-1"
              :disabled="currentPage >= totalPages"
              @click="nextPage"
            >
              <feather-icon
                icon="ChevronRightIcon"
                size="16"
              />
            </b-button>
            <b-button
              variant="link"
              size="sm"
              class="text-white p-1 ml-2"
              @click="zoomOut"
            >
              <feather-icon
                icon="ZoomOutIcon"
                size="16"
              />
            </b-button>
            <span class="budget-pdf-indicator">{{ Math.round(pdfScale * 100) }}%</span>
            <b-button
              variant="link"
              size="sm"
              class="text-white p-1"
              @click="zoomIn"
            >
              <feather-icon
                icon="ZoomInIcon"
                size="16"
              />
            </b-button>
            <b-button
              variant="link"
              size="sm"
              class="text-white p-1 ml-2"
              @click="closePdfViewer"
            >
              <feather-icon
                icon="XIcon"
                size="18"
              />
            </b-button>
          </div>
        </div>
        <div class="budget-pdf-content">
          <pdf
            v-if="currentPdfSrc"
            :src="currentPdfSrc"
            :page="currentPage"
            :quality="3"
            :text="true"
            :annotations="true"
            :style="{
              transform: `scale(${pdfScale})`,
              transformOrigin: 'top center',
              width: '760px',
              minHeight: '1000px'
            }"
            @num-pages="onNumPagesLoaded"
            @loading-failed="closePdfViewer"
          />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import { BButton, BModal } from 'bootstrap-vue'
import pdf from 'vue-pdf'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'BudgetMainSummary',
  CHECKLIST_CATEGORY_EXCLUDED: 'kizarasok',
  CHECKLIST_CATEGORY_REMARKS: 'megjegyzesek',
  components: {
    BButton,
    BModal,
    pdf,
  },
  props: {
    offerType: {
      type: String,
      default: '',
    },
    offerId: {
      type: [Number, String],
      default: null,
    },
    offerName: {
      type: String,
      default: '',
    },
    includeOptionalInSummary: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      summaryRows: [],
      summaryNetBase: 0,
      optionalNetTotal: 0,
      vatPercentInput: '0,00',
      excludedPopupOpen: false,
      excludedPopupDirection: 'down',
      newExcludedItem: '',
      excludedChecked: [],
      remarksPopupOpen: false,
      remarksPopupDirection: 'down',
      newRemarksItem: '',
      remarksChecked: [],
      summaryData: {
        recipient: '',
        subject: '',
        location: '',
        workId: '',
        createdAt: '',
      },
      mainSummaryMetaSaving: false,
      mainSummaryMetaSaved: false,
      mainSummaryMetaTimer: null,
      isExportingPdf: false,
      showPdfViewer: false,
      currentPdfSrc: null,
      currentPage: 1,
      totalPages: 1,
      pdfScale: 1,
      excludedItems: [
        { id: -1, text: 'Rámpa kivitelezésének költségét' },
        { id: -2, text: 'Ideiglenes közművek biztosítását' },
        { id: -3, text: 'Őrzés-védelem költségeit' },
        { id: -4, text: 'Gépesítési szerelvények elhelyezésének költségeit' },
      ],
      remarksItems: [
        { id: -11, text: 'A vasbeton szerkezetbe esetlegesen beépítésre kerülő elektromos és egyéb rendszerek csövezésének betontakarás előtti kiépítéséről a Megrendelőnek kell gondoskodnia!' },
        { id: -12, text: 'Az ajánlatban szereplő betonfelületek az MSZ 24803-1 és MSZ 24803-6-3 NORMAL követelményszintnek megfelelő minőségű betonként kerültek beárazásra.' },
        { id: -13, text: 'Az ajánlatban szereplő betonfelületek NEM LÁTSZÓBETON felületi minőségűek!' },
        { id: -14, text: 'Az ajánlatban szereplő mennyiségektől vagy minőségektől való eltérés esetén (pl. zsaluzási mennyiség, alapozási sík, beton mennyiségek változása, stb.) a kivitelezés költségeinek és határidejének a módosulását vonja maga után!' },
        { id: -15, text: 'Ajánlatunk csak folyamatos, akadályoztatásmentes munkavégzés esetén érvényes.' },
        { id: -16, text: 'Esetleges géptunka rezsi óradíj: 7500 Ft/óra/fő!' },
        { id: -17, text: 'Az ajánlatban a beton anyagok bedolgozási díja betonozó konténerrel, vagy betonszivattyús technológiával való bedolgozás esetén került meghatározásra, melyhez a beton és a betonszivattyú a Kivitelező biztosítja.' },
        { id: -18, text: 'Ajánlatunkban a betonacél szerelési díja a méretre gyártott, pozíciószámmal ellátott és építési helyszínre kiszállított betonacélra vonatkozik, melyet a Kivitelező biztosít.' },
        { id: -19, text: 'A víztelenítés során keletkezett víz mennyiségét a csapadékvíz-elvezető csatorna műtárgyaiba (tisztítóakna, víznyelő, stb.) vezetjük, amihez a vízmi engedélyeztetés a Megrendelő feladata.' },
        { id: -20, text: 'A toronydaru üzemeltetéséhez (35K) a Megrendelőnek kell biztosítani 3x60A, a toronydaru alaplemezéhez.' },
      ],
    }
  },
  computed: {
    mainNetTotal() {
      const base = Number(this.summaryNetBase) || 0
      return this.includeOptionalInSummary ? base + (Number(this.optionalNetTotal) || 0) : base
    },
    vatPercentNumber() {
      const parsed = Number.parseFloat(String(this.vatPercentInput || '0').replace('%', '').trim().replace(',', '.'))
      if (!Number.isFinite(parsed) || parsed < 0) return 0
      return parsed
    },
    vatAmount() {
      return Math.round((Number(this.mainNetTotal) || 0) * (this.vatPercentNumber / 100))
    },
    mainTotalWithVat() {
      return (Number(this.mainNetTotal) || 0) + this.vatAmount
    },
    checkedExcludedItems() {
      const selected = new Set(this.excludedChecked || [])
      return (this.excludedItems || []).filter(item => selected.has(item.id)).map(item => item.text)
    },
    checkedRemarksItems() {
      const selected = new Set(this.remarksChecked || [])
      return (this.remarksItems || []).filter(item => selected.has(item.id)).map(item => item.text)
    },
    excelLikeRows() {
      const totalMaterial = this.summaryRows.reduce((sum, row) => sum + (Number(row.material_total) || 0), 0)
      const totalFee = this.summaryRows.reduce((sum, row) => sum + (Number(row.fee_total) || 0), 0)
      return [
        {
          label: '1. Építmény közvetlen költségei',
          vat: '',
          isMergedAmount: false,
          material: this.formatFt(totalMaterial),
          fee: this.formatFt(totalFee),
        },
        {
          label: '1.1 Közvetlen önköltség összesen',
          vat: '',
          isMergedAmount: false,
          material: this.formatFt(totalMaterial),
          fee: this.formatFt(totalFee),
        },
        {
          label: '2.1 ÁFA vetítési alap',
          vat: '',
          isMergedAmount: true,
          amount: this.formatFt(this.mainNetTotal),
        },
        {
          label: '2.2 Áfa',
          vat: '',
          isVatInput: true,
          isMergedAmount: true,
          amount: this.formatNumber(this.vatAmount),
        },
      ]
    },
  },
  watch: {
    offerType() {
      this.loadSummary()
    },
    offerId() {
      this.loadSummary()
    },
  },
  mounted() {
    this.loadSummary()
  },
  beforeDestroy() {
    if (this.mainSummaryMetaTimer) {
      clearTimeout(this.mainSummaryMetaTimer)
      this.mainSummaryMetaTimer = null
      this.saveMainSummaryMeta()
    }
    this.closePdfViewer()
  },
  methods: {
    scheduleMainSummaryMetaSave() {
      this.mainSummaryMetaSaved = false
      if (this.mainSummaryMetaTimer) {
        clearTimeout(this.mainSummaryMetaTimer)
      }
      this.mainSummaryMetaTimer = setTimeout(() => {
        this.mainSummaryMetaTimer = null
        this.saveMainSummaryMeta()
      }, 700)
    },
    async loadMainSummaryMeta() {
      const offerType = String(this.offerType || '')
      const offerId = Number(this.offerId || 0)
      if (!offerType || !offerId) return

      const response = await axios({
        method: 'get',
        url: 'budget/offer/main-summary',
        params: {
          offer_type: offerType,
          offer_id: offerId,
        },
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      })

      const payload = response?.data || {}
      this.summaryData = {
        recipient: String(payload.recipient || ''),
        subject: String(payload.subject || ''),
        location: String(payload.location || ''),
        workId: String(payload.work_id || ''),
        createdAt: String(payload.created_at_label || ''),
      }
    },
    async saveMainSummaryMeta(silent = true) {
      const offerType = String(this.offerType || '')
      const offerId = Number(this.offerId || 0)
      if (!offerType || !offerId || this.mainSummaryMetaSaving) return

      this.mainSummaryMetaSaving = true
      try {
        await axios({
          method: 'post',
          url: 'budget/offer/main-summary',
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          data: {
            offer_type: offerType,
            offer_id: offerId,
            recipient: this.summaryData.recipient || '',
            subject: this.summaryData.subject || '',
            location: this.summaryData.location || '',
            work_id: this.summaryData.workId || '',
            created_at_label: this.summaryData.createdAt || '',
          },
        })
        this.mainSummaryMetaSaved = true
        if (!silent) {
          setTimeout(() => {
            this.mainSummaryMetaSaved = false
          }, 1800)
        }
      } catch (e) {
        if (!silent) {
          this.mainSummaryMetaSaved = false
        }
      } finally {
        this.mainSummaryMetaSaving = false
      }
    },
    async fetchBudgetPdfBlob() {
      const offerType = String(this.offerType || '')
      const offerId = Number(this.offerId || 0)
      if (!offerType || !offerId) return null

      await this.saveMainSummaryMeta()

      const response = await axios({
        method: 'post',
        url: 'budget/offer/generate-pdf',
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
        data: {
          offer_type: offerType,
          offer_id: offerId,
          offer_name: this.offerName || '',
          vat_percent: this.vatPercentNumber,
        },
      })

      return new Blob([response.data], { type: 'application/pdf' })
    },
    async downloadBudgetPdf() {
      if (this.isExportingPdf) return
      this.isExportingPdf = true
      try {
        const blob = await this.fetchBudgetPdfBlob()
        if (!blob) return

        const url = window.URL.createObjectURL(blob)
        const safeName = String(this.offerName || 'ajanlat').trim().replace(/[\\\\/:*?\"<>|]/g, '-')
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `koltsegvetes-${safeName || 'ajanlat'}.pdf`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } finally {
        this.isExportingPdf = false
      }
    },
    async openBudgetPdfViewer() {
      if (this.isExportingPdf) return
      this.isExportingPdf = true
      try {
        const blob = await this.fetchBudgetPdfBlob()
        if (!blob) return
        this.closePdfViewer()
        this.currentPdfSrc = window.URL.createObjectURL(blob)
        this.currentPage = 1
        this.totalPages = 1
        this.pdfScale = 1
        this.showPdfViewer = true
      } finally {
        this.isExportingPdf = false
      }
    },
    async printSummary() {
      if (this.isExportingPdf) return
      const printWindow = window.open('', '_blank')
      this.isExportingPdf = true
      try {
        const blob = await this.fetchBudgetPdfBlob()
        if (!blob) {
          if (printWindow) printWindow.close()
          return
        }

        const url = window.URL.createObjectURL(blob)
        if (printWindow) {
          printWindow.location.href = url
          setTimeout(() => {
            try {
              printWindow.focus()
              printWindow.print()
            } catch (e) {
              // A böngésző PDF nézője néha csak kézi nyomtatást enged.
            }
          }, 1200)
          setTimeout(() => window.URL.revokeObjectURL(url), 60000)
        } else {
          const link = document.createElement('a')
          link.href = url
          link.target = '_blank'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          setTimeout(() => window.URL.revokeObjectURL(url), 60000)
        }
      } finally {
        this.isExportingPdf = false
      }
    },
    closePdfViewer() {
      this.showPdfViewer = false
      if (this.currentPdfSrc) {
        window.URL.revokeObjectURL(this.currentPdfSrc)
      }
      this.currentPdfSrc = null
      this.currentPage = 1
      this.totalPages = 1
      this.pdfScale = 1
    },
    onNumPagesLoaded(total) {
      const pages = Number(total || 1)
      this.totalPages = Number.isFinite(pages) && pages > 0 ? pages : 1
      if (this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages
      }
    },
    previousPage() {
      if (this.currentPage > 1) this.currentPage -= 1
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage += 1
    },
    zoomIn() {
      if (this.pdfScale < 2.5) this.pdfScale = Number((this.pdfScale + 0.1).toFixed(2))
    },
    zoomOut() {
      if (this.pdfScale > 0.6) this.pdfScale = Number((this.pdfScale - 0.1).toFixed(2))
    },
    formatNumber(value) {
      const num = Number(value || 0)
      const rounded = Number.isFinite(num) ? Math.round(num) : 0
      return rounded.toLocaleString('hu-HU')
    },
    formatFt(value) {
      const num = Number(value || 0)
      const rounded = Number.isFinite(num) ? Math.round(num) : 0
      return `${rounded.toLocaleString('hu-HU')} Ft`
    },
    onVatInput(event) {
      const raw = String(event && event.target ? event.target.value : this.vatPercentInput || '')
      const cleaned = raw
        .replace(/[^0-9.,]/g, '')
        .replace(/\./g, ',')
        .replace(/,+/g, ',')
      const parts = cleaned.split(',')
      const normalized = parts.length > 1
        ? `${parts[0]},${parts.slice(1).join('').slice(0, 2)}`
        : parts[0]
      this.vatPercentInput = normalized
    },
    formatVatInput() {
      const value = this.vatPercentNumber
      this.vatPercentInput = value.toLocaleString('hu-HU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
    toggleExcludedPopup() {
      this.excludedPopupOpen = !this.excludedPopupOpen
      if (this.excludedPopupOpen) {
        this.$nextTick(() => this.updateExcludedPopupDirection())
      }
    },
    openExcludedPopup() {
      if (this.excludedPopupOpen) return
      this.remarksPopupOpen = false
      this.excludedPopupOpen = true
      this.$nextTick(() => this.updateExcludedPopupDirection())
    },
    updateExcludedPopupDirection() {
      const panel = this.$refs.notesPanel
      if (!panel || typeof panel.getBoundingClientRect !== 'function') return
      const rect = panel.getBoundingClientRect()
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0
      const popupHeight = 390
      const spaceBelow = viewportHeight - rect.bottom
      const spaceAbove = rect.top
      this.excludedPopupDirection = spaceBelow < popupHeight && spaceAbove > spaceBelow ? 'up' : 'down'
    },
    addExcludedItem() {
      this.addChecklistItem({
        category: this.$options.CHECKLIST_CATEGORY_EXCLUDED,
        value: this.newExcludedItem,
        itemsKey: 'excludedItems',
        checkedKey: 'excludedChecked',
        inputKey: 'newExcludedItem',
      })
    },
    openRemarksPopup() {
      if (this.remarksPopupOpen) return
      this.excludedPopupOpen = false
      this.remarksPopupOpen = true
      this.$nextTick(() => this.updateRemarksPopupDirection())
    },
    updateRemarksPopupDirection() {
      const panel = this.$refs.remarksPanel
      if (!panel || typeof panel.getBoundingClientRect !== 'function') return
      const rect = panel.getBoundingClientRect()
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0
      const popupHeight = 390
      const spaceBelow = viewportHeight - rect.bottom
      const spaceAbove = rect.top
      this.remarksPopupDirection = spaceBelow < popupHeight && spaceAbove > spaceBelow ? 'up' : 'down'
    },
    addRemarksItem() {
      this.addChecklistItem({
        category: this.$options.CHECKLIST_CATEGORY_REMARKS,
        value: this.newRemarksItem,
        itemsKey: 'remarksItems',
        checkedKey: 'remarksChecked',
        inputKey: 'newRemarksItem',
      })
    },
    normalizeChecklistText(value) {
      return String(value || '')
        .trim()
        .replace(/\s+/g, ' ')
        .toLowerCase()
    },
    async addChecklistItem({
      category,
      value,
      itemsKey,
      checkedKey,
      inputKey,
    }) {
      const text = String(value || '').trim()
      if (!text) return

      const normalizedText = this.normalizeChecklistText(text)
      const items = Array.isArray(this[itemsKey]) ? this[itemsKey] : []
      const existing = items.find(item => this.normalizeChecklistText(item.text) === normalizedText)
      let itemId = existing ? Number(existing.id) : 0

      try {
        if (!itemId) {
          itemId = await this.createChecklistItem(category, text)
          if (!itemId) return
          this[itemsKey] = [...items, { id: itemId, text }]
        }

        const checkedIds = (Array.isArray(this[checkedKey]) ? this[checkedKey] : []).map(id => Number(id))
        if (!checkedIds.includes(Number(itemId))) {
          this[checkedKey] = [...checkedIds, Number(itemId)]
        }

        this[inputKey] = ''
        await this.persistChecklist(
          category,
          this[itemsKey].map(item => Number(item.id)),
          this[checkedKey],
        )
      } catch (e) {
        const message = e?.response?.data?.message || 'Új checklist tétel mentése sikertelen'
        this.notify(message, 'danger', 'XOctagonIcon')
        // A mező maradjon kitöltve, hogy sikertelen mentésnél ne vesszen el a beírt szöveg.
      }
    },
    async loadChecklist(category) {
      const offerType = String(this.offerType || '')
      const offerId = Number(this.offerId || 0)
      if (!offerType || !offerId) return { items: [], checked: [] }
      const headers = { Authorization: `Bearer ${localStorage.getItem('token')}` }
      const [itemsRes, entriesRes] = await Promise.all([
        axios({
          method: 'get',
          url: 'budget/subgroup-mapping/items',
          params: { category },
          headers,
        }),
        axios({
          method: 'get',
          url: 'budget/offer/entries',
          params: {
            offer_type: offerType,
            offer_id: offerId,
            category,
            subgroup_key: '',
          },
          headers,
        }),
      ])
      const items = Array.isArray(itemsRes.data?.rows) ? itemsRes.data.rows : []
      const entryRows = Array.isArray(entriesRes.data?.rows) ? entriesRes.data.rows : []
      const checked = entryRows
        .filter(row => Number(row.qty || 0) > 0)
        .map(row => Number(row.id))
      return {
        items: items.map(item => ({ id: Number(item.id), text: String(item.item_text || '') })),
        checked,
      }
    },
    async persistChecklist(category, itemIds, checkedIds) {
      const offerType = String(this.offerType || '')
      const offerId = Number(this.offerId || 0)
      if (!offerType || !offerId) return
      const checkedSet = new Set((checkedIds || []).map(id => Number(id)))
      const entries = (itemIds || []).map(itemId => ({
        item_id: Number(itemId),
        qty: checkedSet.has(Number(itemId)) ? 1 : 0,
        unit: '',
        material_unit_price: 0,
        base_fee_unit: 0,
      }))
      await axios({
        method: 'post',
        url: 'budget/offer/entries',
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        data: {
          offer_type: offerType,
          offer_id: offerId,
          category,
          subgroup_key: '',
          entries,
        },
      })
    },
    saveExcludedState() {
      const itemIds = this.excludedItems.map(item => Number(item.id))
      this.persistChecklist(this.$options.CHECKLIST_CATEGORY_EXCLUDED, itemIds, this.excludedChecked).catch(() => {})
    },
    saveRemarksState() {
      const itemIds = this.remarksItems.map(item => Number(item.id))
      this.persistChecklist(this.$options.CHECKLIST_CATEGORY_REMARKS, itemIds, this.remarksChecked).catch(() => {})
    },
    async createChecklistItem(category, itemText) {
      const response = await axios({
        method: 'post',
        url: 'budget/subgroup-mapping/create-item',
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        data: {
          category,
          subgroup_key: '',
          item_text: itemText,
        },
      })
      const id = Number(response.data?.id || 0)
      return id > 0 ? id : null
    },
    notify(title, variant = 'success', icon = 'CheckIcon') {
      if (!this.$toast) return
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon,
          variant,
        },
      })
    },
    async loadChecklistCards() {
      try {
        const [excluded, remarks] = await Promise.all([
          this.loadChecklist(this.$options.CHECKLIST_CATEGORY_EXCLUDED),
          this.loadChecklist(this.$options.CHECKLIST_CATEGORY_REMARKS),
        ])
        if (excluded.items.length) {
          this.excludedItems = excluded.items
        }
        this.excludedChecked = excluded.checked
        if (remarks.items.length) {
          this.remarksItems = remarks.items
        }
        this.remarksChecked = remarks.checked
      } catch (e) {
        // fallback marad a lokális default lista
      }
    },
    async loadSummary() {
      const offerType = String(this.offerType || '')
      const offerId = Number(this.offerId || 0)
      if (!offerType || !offerId) return

      const token = localStorage.getItem('token')
      const headers = { Authorization: `Bearer ${token}` }

      try {
        const [summaryRes, optionalRes] = await Promise.all([
          axios({
            method: 'get',
            url: 'budget/offer/entries',
            params: {
              offer_type: offerType,
              offer_id: offerId,
              category: 'osszesito',
              subgroup_key: '',
            },
            headers,
          }),
          axios({
            method: 'get',
            url: 'budget/offer/entries',
            params: {
              offer_type: offerType,
              offer_id: offerId,
              category: 'opcios-munkak',
              subgroup_key: '',
            },
            headers,
          }),
        ])

        const summaryRows = Array.isArray(summaryRes.data?.rows) ? summaryRes.data.rows : []
        const optionalRows = Array.isArray(optionalRes.data?.rows) ? optionalRes.data.rows : []

        this.summaryRows = summaryRows
        this.summaryNetBase = summaryRows.reduce((sum, row) => sum + (Number(row.material_total) || 0) + (Number(row.fee_total) || 0), 0)
        this.optionalNetTotal = optionalRows.reduce((sum, row) => sum + (Number(row.material_total) || 0) + (Number(row.fee_total) || 0), 0)
        this.vatPercentInput = '0,00'
        await this.loadChecklistCards()
        await this.loadMainSummaryMeta()
      } catch (e) {
        this.summaryRows = []
        this.summaryNetBase = 0
        this.optionalNetTotal = 0
        this.vatPercentInput = '0,00'
        this.summaryData = {
          recipient: '',
          subject: '',
          location: '',
          workId: '',
          createdAt: '',
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.prep-main-summary {
  width: 100%;
  height: 100%;
}

.prep-main-summary-panel {
  min-height: calc(100vh - 320px);
  border-radius: 14px;
  padding: 14px;
  border: 1px solid color-mix(in srgb, var(--prep-accent-soft) 24%, rgba(148, 163, 184, 0.25) 76%);
  background:
    radial-gradient(800px 260px at 12% 0%, rgba(236, 72, 153, 0.12) 0%, transparent 68%),
    linear-gradient(180deg, rgba(20, 28, 55, 0.95) 0%, rgba(14, 22, 46, 0.96) 100%);
}

.prep-main-summary-title {
  text-align: center;
  font-weight: 700;
  font-size: 1.45rem;
  margin-bottom: 10px;
}

.prep-main-summary-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 14px;
}

.prep-main-summary-meta {
  --card-accent: rgba(56, 189, 248, 0.95);
  border: 1px solid rgba(148, 163, 184, 0.45);
  border-radius: 14px;
  overflow: visible;
  display: grid;
  gap: 14px;
  padding: 16px 12px 12px;
}

.prep-main-summary-meta-row {
  display: grid;
  grid-template-columns: 170px 1fr;
}

.prep-main-summary-meta-row .label,
.prep-main-summary-meta-row .value {
  padding: 0;
  border-bottom: 0;
}

.prep-main-summary-meta-row .label {
  background: rgba(32, 42, 75, 0.5);
}

.prep-main-summary-meta-row .value {
  background: rgba(18, 28, 56, 0.55);
}

.prep-main-summary-meta-row .meta-box {
  min-height: 40px;
  border-radius: 10px;
  border: 1px solid rgba(96, 165, 250, 0.45);
  background: rgba(17, 26, 54, 0.7);
  display: flex;
  align-items: center;
  padding: 6px 10px;
  color: #dbe4ff;
}

.prep-main-summary-meta-row .meta-box-label {
  font-weight: 700;
  border-color: rgba(232, 121, 249, 0.45);
}

.prep-main-summary-meta-row .meta-box-value {
  font-weight: 500;
}

.prep-main-summary-meta-row .meta-input {
  width: 100%;
  border: 0;
  outline: none;
  background: transparent;
  color: #dbe4ff;
  font-weight: 500;
}

.prep-main-summary-meta-row .meta-input::placeholder {
  color: rgba(203, 213, 225, 0.65);
}

.prep-main-summary-table-wrap {
  --card-accent: rgba(236, 72, 153, 0.95);
  margin-top: 24px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  border-radius: 14px;
  overflow: hidden;
  padding-top: 8px;
}

.prep-main-summary-table {
  --summary-col-name: 35%;
  --summary-col-vat: 104px;
  --summary-col-material: 20%;
  --summary-col-fee: 20%;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 16px;
  table-layout: fixed;
}

.prep-main-summary-table col.col-name {
  width: var(--summary-col-name);
}

.prep-main-summary-table col.col-vat {
  width: var(--summary-col-vat);
}

.prep-main-summary-table col.col-material {
  width: var(--summary-col-material);
}

.prep-main-summary-table col.col-fee {
  width: var(--summary-col-fee);
}

.prep-main-summary-table th,
.prep-main-summary-table td {
  padding: 2px 10px;
  border-bottom: 0;
}

.prep-main-summary-table .vat-col {
  text-align: right;
}

.prep-main-summary-table .merged-amount {
  text-align: center;
}

.prep-main-summary-table .cell-box {
  min-height: 40px;
  border-radius: 10px;
  border: 1px solid rgba(96, 165, 250, 0.45);
  background: rgba(17, 26, 54, 0.7);
  display: flex;
  align-items: center;
  padding: 6px 10px;
  color: #dbe4ff;
}

.prep-main-summary-table .cell-box-name {
  border-color: rgba(232, 121, 249, 0.45);
  justify-content: flex-start;
}

.prep-main-summary-table .cell-box-vat {
  justify-content: center;
}

.prep-main-summary-table .vat-input-wrap {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: 100%;
}

.prep-main-summary-table .vat-input {
  width: 100%;
  border: 0;
  outline: none;
  background: transparent;
  color: #dbe4ff;
  text-align: right;
  font-weight: 700;
}

.prep-main-summary-table .vat-symbol {
  color: #dbe4ff;
  font-weight: 700;
  opacity: 0.9;
}

.prep-main-summary-table .cell-box-number {
  justify-content: center;
  font-weight: 700;
}

.prep-main-summary-table .cell-box-merged {
  justify-content: center;
  font-weight: 700;
}

.prep-main-summary-table th {
  text-align: left;
  font-weight: 700;
  background: transparent;
  padding-top: 0;
  padding-bottom: 2px;
}

.prep-main-summary-table th:nth-child(3),
.prep-main-summary-table th:nth-child(4) {
  text-align: center;
}

.prep-main-summary-table .head-box {
  min-height: 34px;
  border-radius: 10px;
  border: 1px solid rgba(96, 165, 250, 0.35);
  background: rgba(35, 45, 77, 0.78);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 6px 10px;
}

.prep-main-summary-table th:nth-child(3) .head-box,
.prep-main-summary-table th:nth-child(4) .head-box {
  justify-content: center;
}

.prep-main-summary-table td {
  background: rgba(19, 27, 53, 0.72);
}

.prep-main-summary-table td.empty {
  text-align: center;
  color: #cbd5e1;
}

.prep-main-summary-highlight {
  --card-accent: rgba(250, 204, 21, 0.95);
  margin-top: 20px;
  display: grid;
  gap: 12px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  border-radius: 14px;
  padding: 16px 10px 10px;
}

.prep-main-summary-highlight .line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid rgba(250, 204, 21, 0.55);
  background:
    linear-gradient(90deg, rgba(250, 204, 21, 0.22) 0%, rgba(250, 204, 21, 0.12) 28%, rgba(17, 26, 54, 0.82) 62%),
    rgba(17, 26, 54, 0.72);
  color: #f8fafc;
  font-weight: 700;
  box-shadow:
    inset 0 0 0 1px rgba(250, 204, 21, 0.18),
    0 6px 18px rgba(15, 23, 42, 0.24);
}

.prep-main-summary-highlight .line strong {
  color: #fde68a;
  letter-spacing: 0.2px;
}

.prep-main-summary-notes {
  --card-accent: rgba(167, 139, 250, 0.95);
  position: relative;
  margin-top: 22px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  border-radius: 14px;
  padding: 16px 8px 8px;
}

.prep-main-summary-remarks {
  --card-accent: rgba(244, 63, 94, 0.95);
}

.prep-main-summary-remarks .notes-selected-item,
.prep-main-summary-remarks .notes-item,
.prep-main-summary-remarks .notes-item span,
.prep-main-summary-remarks .notes-popup-title {
  color: #f87171;
}

.prep-main-summary-remarks .notes-selected-item::before {
  color: #fda4af;
}

.prep-main-summary-meta,
.prep-main-summary-table-wrap,
.prep-main-summary-highlight,
.prep-main-summary-notes {
  position: relative;
  background:
    radial-gradient(840px 250px at 10% 0%, rgba(236, 72, 153, 0.11) 0%, transparent 66%),
    linear-gradient(120deg, rgba(28, 38, 70, 0.92) 0%, rgba(16, 25, 52, 0.92) 100%);
  box-shadow:
    inset 0 0 0 1px rgba(96, 165, 250, 0.14),
    0 14px 30px rgba(2, 8, 23, 0.32);
}

.prep-main-summary-meta::before,
.prep-main-summary-table-wrap::before,
.prep-main-summary-highlight::before,
.prep-main-summary-notes::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 12px;
  border-radius: 14px 14px 0 0;
  background: linear-gradient(90deg, rgba(236, 72, 153, 0.13) 0%, rgba(167, 139, 250, 0.09) 35%, rgba(96, 165, 250, 0.06) 100%);
  border-bottom: 1px solid rgba(148, 163, 184, 0.14);
  pointer-events: none;
}

.prep-main-summary-meta::after,
.prep-main-summary-table-wrap::after,
.prep-main-summary-highlight::after,
.prep-main-summary-notes::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  border-radius: 14px 0 0 14px;
  background: linear-gradient(180deg, color-mix(in srgb, var(--card-accent) 100%, white 0%) 0%, rgba(15, 23, 42, 0.16) 100%);
  box-shadow: 0 0 16px color-mix(in srgb, var(--card-accent) 55%, transparent 45%);
  pointer-events: none;
}

.prep-main-summary-notes .notes-trigger {
  width: 100%;
  min-height: 42px;
  border-radius: 10px;
  border: 1px solid rgba(232, 121, 249, 0.45);
  background: rgba(17, 26, 54, 0.72);
  color: #dbe4ff;
  font-weight: 700;
  padding: 8px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.prep-main-summary-notes .notes-selected-list {
  margin-top: 10px;
  display: grid;
  gap: 16px;
}

.prep-main-summary-notes .notes-selected-item {
  border-radius: 8px;
  border: 1px solid rgba(96, 165, 250, 0.42);
  background: rgba(17, 26, 54, 0.62);
  padding: 8px 12px 8px 18px;
  color: #dbe4ff;
  font-size: 0.88rem;
  line-height: 1.55;
  text-align: left;
  text-indent: 8px;
}

.prep-main-summary-notes .notes-selected-item::before {
  content: '-';
  margin-right: 6px;
  color: rgba(148, 163, 184, 0.92);
}

/* Keep the 5th card ("Megjegyzések") text red on the card too. */
.prep-main-summary-remarks .notes-selected-item,
.prep-main-summary-remarks .notes-selected-item::before {
  color: #f87171;
}

.prep-main-summary-notes .notes-popup {
  position: absolute;
  left: 0;
  top: calc(100% + 8px);
  width: min(760px, calc(100vw - 72px));
  max-height: 380px;
  overflow: auto;
  border-radius: 12px;
  border: 1px solid rgba(96, 165, 250, 0.45);
  background:
    radial-gradient(560px 190px at 7% 0%, rgba(236, 72, 153, 0.12) 0%, transparent 66%),
    rgba(16, 24, 49, 0.98);
  box-shadow: 0 16px 40px rgba(2, 8, 23, 0.48);
  padding: 10px;
  z-index: 20;
}

.prep-main-summary-notes .notes-popup.notes-popup--up {
  top: auto;
  bottom: calc(100% + 8px);
}

.prep-main-summary-notes .notes-popup.notes-popup--down {
  top: calc(100% + 8px);
  bottom: auto;
}

.prep-main-summary-notes .notes-popup-title {
  font-weight: 700;
  margin-bottom: 8px;
  color: #e2e8f0;
}

.prep-main-summary-notes .notes-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 10px;
  border-radius: 8px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  background: rgba(17, 26, 54, 0.58);
  margin-bottom: 16px;
}

.prep-main-summary-notes .notes-item input[type="checkbox"] {
  margin-top: 2px;
}

.prep-main-summary-notes .notes-add-row {
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 8px;
  margin-top: 10px;
}

.prep-main-summary-notes .notes-add-input {
  border-radius: 10px;
  border: 1px solid rgba(96, 165, 250, 0.5);
  background: rgba(17, 26, 54, 0.82);
  color: #dbe4ff;
  padding: 8px 10px;
  outline: none;
}

.prep-main-summary-notes .notes-add-btn {
  border-radius: 10px;
  border: 1px solid rgba(232, 121, 249, 0.55);
  background: rgba(76, 29, 149, 0.24);
  color: #f8fafc;
  font-weight: 700;
  padding: 8px 12px;
  cursor: pointer;
}

.prep-main-summary-notes .notes-close-btn {
  border-radius: 10px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  background: rgba(30, 41, 59, 0.45);
  color: #e2e8f0;
  font-weight: 700;
  padding: 8px 12px;
  cursor: pointer;
}

.notes-pop-enter-active,
.notes-pop-leave-active {
  transition: opacity 0.16s ease, transform 0.16s ease;
}

.notes-pop-enter,
.notes-pop-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

::v-deep .budget-pdf-modal {
  .modal-dialog {
    max-width: 95vw !important;
    height: calc(100vh - 24px) !important;
    margin: 12px auto !important;
  }

  .modal-content {
    height: 100% !important;
    border: 0 !important;
    border-radius: 12px !important;
    overflow: hidden !important;
    background: transparent !important;
  }

  .modal-body {
    height: 100% !important;
    padding: 0 !important;
  }
}

.budget-pdf-viewer {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #0f172a;
}

.budget-pdf-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.35);
}

.budget-pdf-title {
  color: #e2e8f0;
  font-weight: 700;
}

.budget-pdf-controls {
  display: flex;
  align-items: center;
}

.budget-pdf-indicator {
  color: #cbd5e1;
  min-width: 56px;
  text-align: center;
  font-size: 0.85rem;
}

.budget-pdf-content {
  flex: 1;
  overflow: auto;
  display: flex;
  justify-content: center;
  padding: 14px;
}

@media print {
  .prep-main-summary-actions,
  .notes-popup,
  .notes-add-row {
    display: none !important;
  }

  .prep-main-summary-panel {
    background: #fff !important;
    border: 1px solid #334155 !important;
    box-shadow: none !important;
  }

  .prep-main-summary-meta,
  .prep-main-summary-table-wrap,
  .prep-main-summary-highlight,
  .prep-main-summary-notes {
    background: #fff !important;
    box-shadow: none !important;
    border-color: #64748b !important;
  }

  .prep-main-summary-meta::before,
  .prep-main-summary-table-wrap::before,
  .prep-main-summary-highlight::before,
  .prep-main-summary-notes::before,
  .prep-main-summary-meta::after,
  .prep-main-summary-table-wrap::after,
  .prep-main-summary-highlight::after,
  .prep-main-summary-notes::after {
    display: none !important;
  }

  .prep-main-summary-table .cell-box,
  .prep-main-summary-table .head-box,
  .prep-main-summary-meta-row .meta-box,
  .prep-main-summary-highlight .line,
  .prep-main-summary-notes .notes-trigger,
  .prep-main-summary-notes .notes-selected-item {
    background: #fff !important;
    color: #111827 !important;
    border-color: #94a3b8 !important;
    box-shadow: none !important;
  }
}
</style>
